<template>
    <div class="card border-0 h-800">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" class="mb-0" :class="{ 'loading-opacity': preloader }">
                <ShortName v-model="inputs.Second_Title" />
                <CustomerDescription v-model="inputs.description" />
                <BillAddress v-model="inputs.BillAddress" />
                <CustomerCountry v-model="inputs.country" />    
                <CustomerState v-model="inputs.state" :country_id="inputs.country.id" />
                <CustomerCity v-model="inputs.city" :state_id="inputs.state.id" />
                <PostalCode v-model="inputs.PostalZipCode" />
                <CustomerPhone v-model="inputs.phone" />
                <CustomerFax v-model="inputs.fax" />
                <CustomerEmail v-model="inputs.Email" />
                <CustomerIrs v-model="inputs.irs" />
                <CustomerStatus v-model="inputs.status" :list="stateList" />
                <div class="mt-5 action-buttons">
                    <button type="button" class="btn btn-primary mr-2" @click="continueBy">{{ $t('Continue') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { axiosGet } from "../../../../Helpers/AxiosHelper.js";
import * as actions from "../../../../Config/ApiUrl.js";
import { validateInputs } from "../../../../../utils"
import ShortName from '../components/ShortName.vue';
import CustomerDescription from '../components/CustomerDescription.vue';
import BillAddress from '../components/BillAddress.vue';
import CustomerCountry from '../components/CustomerCountry.vue';
import CustomerState from '../components/CustomerState.vue';
import CustomerCity from '../components/CustomerCity.vue';
import PostalCode from '../components/PostalCode.vue';
import CustomerPhone from '../components/CustomerPhone.vue';
import CustomerFax from '../components/CustomerFax.vue';
import CustomerEmail from '../components/CustomerEmail.vue';
import CustomerIrs from '../components/CustomerIrs.vue';
import CustomerStatus from '../components/CustomerStatus.vue';

export default {
    name: "add_supplier_form",
    mixins: [FormMixin, ModalMixin],
    props: {
        companieData: Object, require: true,
    },
    components :{
        ShortName, CustomerDescription, BillAddress, CustomerCountry, CustomerState, CustomerCity, PostalCode, CustomerPhone, CustomerFax, CustomerEmail, CustomerIrs, CustomerStatus
    },
    data() {
        return {
            preloader: false,
            inputs: {
                Second_Title: '',
                description: '',
                BillAddress: '',
                fax: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
                PostalZipCode: '',
                phone: '',
                Email: '',
                irs: '',
                status: 'active',
                company_type_id: 1,
            },
            stateList: [
                { id: 'active', value: "Active" },
                { id: 'inactive', value: "Inactive" }
            ],
        };
    },

    methods: {
        continueBy() {
            const validations = {
                Second_Title: { required: true, message: 'Short name is required' },
                BillAddress: { required: true, message: 'The BillAddress is required' },
                'country.id': { required: true, message: 'The Country is required' },
                'state.id': { required: true, message: 'The State is required' },
                'city.id': { required: true, message: 'The City is required' },
                PostalZipCode : {required: true, message: 'The Postal zip code is required' },
            };
            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }
            window.location.href = this.$router.resolve({
                name: 'Contacts',
                query: { 'tab': 'Contacts' }
            }).href;
        },
    },

    watch: {
        inputs: {
            deep: true,
            handler(newVal) {
                localStorage.setItem('DataCompanies', JSON.stringify(newVal));
            }
        }
    },

    created() {
        const savedInputs = localStorage.getItem('DataCompanies');
        if (savedInputs) {
            this.inputs = JSON.parse(savedInputs);
        }
    }
}
</script>
